import {RefObject, useEffect} from 'react';

export function useOutsideClick(target: RefObject<any>, onOutsideClick: () => void) {
    const mouseDown = (event: MouseEvent) => {
        if (target.current) {
            if (!target.current.contains(event.target) && onOutsideClick) {
                onOutsideClick();
            }
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', mouseDown);
        return () => document.removeEventListener('mousedown', mouseDown);
    }, []);
}
